var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "product-cases area"
  }, [_c("header", {
    staticClass: "product-cases__title"
  }, [_c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("CASES")]), _c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("客户案例")])]), _c("main", {
    staticClass: "product-cases__main clearfix"
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/service/operating-activities/客户案例—浙商证券.png"),
      alt: ""
    }
  }), _c("p", {
    staticClass: "content"
  }, [_vm._v(" 营销活动免编程创建，减少对开发、设计等人力资源的需求，将活动上线时间由3-7天缩短至10-20分钟，最终解决70-80%的营销活动创建需求。 利用在线图片编辑工具，快速修改图片模板生成需求图片，将绘图时间从1-2天缩短至5-10分钟，替代50%的开发、测试工作量，每年节约100-150万人力成本。 ")])])]);
}];
render._withStripped = true;
export { render, staticRenderFns };